module.exports = __webpack_public_path__ + "28d7b0ec7e05928333fbf83b4099252e.footer.webp";


//////////////////
// WEBPACK FOOTER
// ./components/footer/assets/footer.webp
// module id = wwS1
// module chunks = 0